import styled, { css } from 'styled-components';
import type { Maybe } from 'yup';

import { Box } from '@/components/Box';
import { Content } from '@/components/Cms/Card/components/BaseCardType/BaseCardType.styles';

import { visibilityControl } from '../../Card.styles';
export const StoryWrapper = styled.div<{
  $visibleInDesktop?: Maybe<boolean>;
  $visibleInMobile?: Maybe<boolean>;
}>`
  display: flex;
  ${({ $visibleInDesktop, $visibleInMobile }) => css`
    ${visibilityControl($visibleInDesktop, $visibleInMobile)}
  `};
  ${({ theme }) => css`
    max-width: ${theme.breakpoints.lg};
    padding: ${theme.spacing(0, 2)};
    flex-direction: column;
    margin: ${theme.spacing(5)} auto;
    ${theme.media.md.up} {
      flex-direction: row;
      padding: ${theme.spacing(0, 5)};
    }
  `}
`;

export const Media = styled(Box)<{
  $backgroundAlignment: Maybe<string>;
}>`
  object-fit: cover;
  flex: 1;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      max-width: 50%;
    }
  `}
`;

export const ContentBox = styled(Content)`
  flex: 1;
  ${({ theme }) => css`
    max-height: 100%;
    ${theme.media.md.up} {
      max-width: 50%;
      padding: ${theme.spacing(0, 10)};
    }
  `}
`;
